export type FieldType = 'text' | 'number' | 'date' | 'file' | 'photo' | 'video' | 'audio' | 'gps' | 'dropdown';

export enum DataType {
  Number = 'NUMBER',
  String = 'STRING',
  Date = 'DATE',
  Barcode = 'BARCODE',
  File = 'FILE_PICKER',
  Multiple = 'MULTIPLE',
}

export interface FieldSettings {
  placeholder?: string;
  mask?: string;
  regex?: string;
  fileCount?: number;
  options?: string[];
}

export interface Field {
  id: string;
  name: string;
  type: FieldType;
  defaultValue?: string | number | boolean;
  isRequired: boolean;
  editableAfterSubmit: boolean;
  editModeOnly: boolean;
  settings?: FieldSettings;
}

export interface FieldGroup {
  id: string;
  title: string;
  defaultValue?: string;
  dataType?: DataType;
  fileCount?: number;
  isRequired: boolean;
  editableAfterSubmit: boolean;
  editModeOnly: boolean;
  forWebOnly: boolean;
  modelName: string;
}

export interface Step {
  id: string;
  title: string;
  description?: string;
  saveOnComplete: boolean;
  editModeOnly: boolean;
  fieldGroups: FieldGroup[];
}

export interface StepWithNullableId extends Omit<Step, 'id' | 'fieldGroups'> {
  id: string | null
  fieldGroups: (Omit<FieldGroup, 'id'> & { id: string | null })[]
}

export interface WorkStagesServiceData {
  steps: Step[];
}

export interface WorkStagesDataWithDeviceTypeCode extends WorkStagesServiceData {
  deviceTypeCode: string;
}

export interface FileImportCallbacks {
  onSuccess?: (data: WorkStagesServiceData) => void;
  onError?: (errorMessage: string) => void;
}
